// extracted by mini-css-extract-plugin
export default {"chevron":"ProductHeading_chevron__dgVcT","chevronOpen":"ProductHeading_chevronOpen__2FaXF","rowOne":"ProductHeading_rowOne__Nigax","rowTwo":"ProductHeading_rowTwo__lON0P"};